import type { TrackerMessage, TrackerMessageOverview } from '@racemap/sdk/schema/trackers';
import { getCurrentMessageStatusCode } from '@racemap/utilities/functions/messages';
import type { Immutable } from 'immer';

export const isMessageFinalized = (
  message: Immutable<TrackerMessageOverview | TrackerMessage>,
): boolean => {
  const messageStatusCode = getCurrentMessageStatusCode(message);
  return (
    messageStatusCode === 'COMPLETE' ||
    messageStatusCode === 'DELIVERED' ||
    messageStatusCode === 'ERROR' ||
    messageStatusCode === 'REVOKED' ||
    messageStatusCode === 'CLEARED'
  );
};
